/* eslint-disable import-x/no-default-export, no-restricted-exports */
// This file is auto-generated
export { default, getFullLocale } from '../src/ackermannch';
export type { Config, Locale, Language, GeoCountryCode } from '../src/default/types';
